/**
 * Sample page JS provided here for extension. Might not be useful if all JS is based on components.
 */
class Accordions extends DrupalBehavior {

  onContent(context) {
    // Initialize javascript.
    this.accordions(context);
    this.checkAccordionAnchors(context);
    window.onhashchange = () => {
      this.checkAccordionAnchors(context);
    }
  }

  accordions(context) {
    const elements = $(once('accordions', '.accordions', context));
    // $('.accordions', context).each((index, component) => {
    elements.each((index, component) => {
      const $component = $(component);
      // Open accordion based on URL.
      $component.find('.accordion').each((index2, item) => {
        const $accordionItem = $(item);
        const $accordionItemContainer = $accordionItem.find('> div');
        const height = $accordionItemContainer.prop('scrollHeight');
        if (window.location.hash == '#' + $accordionItem.attr('id')) {
          $accordionItem.find('h3').addClass('active');
          $accordionItemContainer.css('max-height', height);
        }
      });
      // Attach on click
      $component.find('.accordion h3').click(function() {
        const height = $(this).next('div').prop('scrollHeight');
        //console.log(height);
        $(this).toggleClass('active');
        $(this).siblings().removeClass('active');
        $(this).siblings('div').css('max-height', 0);
        if ($(this).hasClass('active')) {
          $(this).next('div').css('max-height', height);
        }
        else {
          $(this).next('div').css('max-height', 0);
        }
      });
    });

    $('.site-wrap a').on('click', function (event) {
      const current_href = $(this).attr('href');
      const has_accordion = current_href.indexOf('#accordion-item');

      if (has_accordion !== -1) {
        const pathname = current_href.split('#');
        const current_hash = '#' + pathname[1];

        if (pathname.length >= 2) {
          // open accordion
          const height = $(current_hash).find('h3').next('div').prop('scrollHeight');
          $(current_hash).find('h3').addClass('active');
          $(current_hash).find('h3').next('div').css('max-height', height);
        }
      }

      return;
    });
  }

  checkAccordionAnchors(context) {
    // Check if there's a URL fragment, without the # symbol.
    const fragment = window.location.hash.slice(1);
    if (!fragment) {
      return;
    }
    // If there is a fragment, check if a corresponding anchor exists.
    var anchor = $('[id="' + fragment + '"]');
    if (!anchor.length) {
      return;
    }
    // If there's an anchor, check if it's in a closed accordion.
    var closedAccordionTrigger = anchor.closest('[data-paragraph-type="accordion"]').find('h3[data-field-name="field_title"]:not(.active)');
    if (!closedAccordionTrigger.length) {
      return;
    }
    // If there's a closed accordion, open it and scroll the anchor into view.
    closedAccordionTrigger.trigger('click');
    // The animation to open is 0.3s. Delay the scroll into view to allow it to finish.
    window.setTimeout(() => {
      anchor[0].scrollIntoView();
    }, 300);
  }

}

DrupalBehavior.register('psh_theme.components', 'accordions', Accordions);
